module.exports = __webpack_public_path__ + "media/images/soar/share-8d7f1380cc37400f4e87d378ee5320c7.png";